'use client';

import type { CSSProperties, FC, PropsWithChildren } from 'react';
import { cx } from '../../utils/cx';
import { typography } from '../../themes/DefaultTheme';
import type { TypographyProps } from './utils/typographyHelper';
import { typographyStyle } from './utils/typographyHelper';
import styles from './typography.module.css';

export interface LabelProps extends TypographyProps {
  className?: string;
  display?: 'block' | 'inline';
}

export const Label: FC<PropsWithChildren<LabelProps>> = ({
  display = 'block',
  className,
  children,
  ...props
}) => {
  const style: CSSProperties = {
    ...typographyStyle(typography.label, props),
    color: 'var(--color-foreground)',
    display,
  };
  return (
    <span className={cx(styles.text, className)} style={style}>
      {children}
    </span>
  );
};
